<script setup>
import { ref, onMounted, computed } from 'vue';
import { useSertStore } from '@/stores/sertStore';
import { useSettingsStore } from '@/stores/settingsStore';
import { useRequestsStore } from '@/stores/storeRequests';
import SertHeader from '@/components/blocks/SertHeader.vue';
import BasePhoneInput from '@/components/ui/BasePhoneInput.vue';
import BaseCheckbox from '@/components/ui/BaseCheckbox.vue';

const storeSert = useSertStore();
const storeSettings = useSettingsStore();
const storeRequests = useRequestsStore();
const isAuth = computed(() => storeRequests.isAuthenticated && storeRequests.userData?.is_full_profile)
const isDisabled = computed(() => storeSert.isBtnDisabled(['phone', 'rules']))

const nextSreen = async () => {
    const response = await storeRequests.authorization();
    if(!response?.success) return;
    storeSert.goToScreen(storeSert.screens.authSms)  
    history.pushState(null, "", `#${storeSert.screens.authSms}`)
    storeSert.timer() 
};



onMounted(() => {
    if(isAuth.value) {
        storeSert.goToScreen(storeSert.screens.services)
        router.push({ hash: `#${storeSert.screens.services}`})
    }
})


</script>
<template>
    <div class="constructor">
        <div class="constructor__body" v-if="!isAuth">
            <SertHeader :white-steps="1">
                <template #title>авторизация</template>
                <template #text>Для доступа к разделу необходимо авторизоваться.</template>
            </SertHeader>            
            <div class="form --form-pay">
                
                <div :class="['form__row ', ]">
                   
                    <BasePhoneInput 
                        placeholder="Укажите номер телефона"
                        state-key="phone"                    
                    >
                        Номер телефона
                    </BasePhoneInput>
                </div>
                <div class="rules">
                    <BaseCheckbox
                        state-key="rules"
                    >
                        Ознакомлен с правилами, согласен на обработку <a target="_blank" :href="storeSettings.policy_personal_data">персональных данных</a>
                    </BaseCheckbox> 
                </div>
                
            </div>
        </div>
        <div class="constructor__btns-inner">
            <p class="text-error" v-if="storeRequests.responseError">{{ storeRequests.responseError }}</p>
            <div class="constructor__btns --full">
                <button 
                    @click="nextSreen"
                    :disabled="isDisabled" 
                    class="btn --full"
                >
                    <span v-if="!storeRequests.loaderBtn">Получить смс-код</span>
                    <img v-else class="form__loader" width="36" height="36" src="@/assets/img/icons/loader_black.png" alt="изображение" />
                </button>
            </div>
        </div>
    </div>
</template>
<style lang='scss' scoped>
.v-enter-active,
.v-leave-active {
  transition: 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>